import { RiskDashboardDto } from "@/features/orders-analytics/types/risk-analytics.types";
import { OrdersAnalyticsFilters } from "@/features/orders-analytics/types/orders-analytics.types";
import { timezone } from "@/features/orders-analytics/utils/timezone";
import { httpClient } from "@/shared/http/httpClient";

const API_PATH = "/api/v1/analytics/risk";

const fetchRiskDashboard = (filters: OrdersAnalyticsFilters): Promise<RiskDashboardDto> => {
    const params = new URLSearchParams();
    params.set("start", timezone.toTimeZoneInputDate(filters.dateFrom));
    params.set("end", timezone.toTimeZoneInputDate(filters.dateTo));

    if (filters.clients.length > 0) {
        params.set("clients", filters.clients.join(","));
    }

    return httpClient.getJson<RiskDashboardDto>(`${API_PATH}?${params.toString()}`);
};

export const riskAnalyticsApi = { fetchRiskDashboard };
